import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import RegisterEditForm from "../../Authentication/RegisterEditForm/View";

const EditUser = ({ userState, actions }) => {
  const { id } = useParams();

  useEffect(() => {
    actions.getUserById(id);
  }, []);

  return (
    userState.currentUser && (
      <div>
        <RegisterEditForm
          isAddUser={false}
          userState={userState}
          actions={actions}
        />
      </div>
    )
  );
};

export default EditUser;
